import { Heading_default } from "./chunk-K742HG2N.js";
import { Link_default } from "./chunk-TK6RORJT.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Dialog/Dialog.Header.tsx
import { CloseButton, DialogTitle } from "@headlessui/react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var DialogHeader = _a => {
  var _b = _a,
    {
      children,
      title,
      variant = "display",
      dismissLabel,
      className
    } = _b,
    rest = __objRest(_b, ["children", "title", "variant", "dismissLabel", "className"]);
  return /* @__PURE__ */jsxs("header", __spreadProps(__spreadValues({
    className: clsx("pd:dialog__header", className)
  }, rest), {
    children: [/* @__PURE__ */jsxs("div", {
      className: "pd:dialog__title",
      children: [/* @__PURE__ */jsx(Heading_default, {
        variant,
        size: "2",
        as: DialogTitle,
        children: title
      }), /* @__PURE__ */jsx(Link_default, {
        as: CloseButton,
        className: "pd:dialog__close",
        variant: "secondary",
        screenReaderLabel: dismissLabel,
        iconBefore: "times"
      })]
    }), children]
  }));
};
var Dialog_Header_default = DialogHeader;
export { Dialog_Header_default };